import { EAccountStatus } from "../enum/EAccountStatus";

export default class LoggedInUserInfo {
    isLoggedIn: boolean | undefined;
    
    status: EAccountStatus | undefined
}